"use client";

import { ReactNode, HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: 'default' | 'elevated' | 'outlined';
  padding?: 'sm' | 'md' | 'lg';
  hover?: boolean;
}

export const Card = ({ 
  children, 
  variant = 'default',
  padding = 'md',
  hover = false,
  className = '', 
  ...props 
}: CardProps) => {
  const baseClasses = "rounded-lg transition-all duration-200";
  
  const variantClasses = {
    default: "bg-white border border-gray-200",
    elevated: "bg-white shadow-md hover:shadow-lg",
    outlined: "bg-white border-2 border-primary-200"
  };
  
  const paddingClasses = {
    sm: "p-4",
    md: "p-6 md:p-8",
    lg: "p-8 md:p-12"
  };
  
  const hoverClasses = hover ? "hover:shadow-md cursor-pointer" : "";

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${paddingClasses[padding]} ${hoverClasses} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};